import { LegacyBetModelBuilder } from './LegacyBetModelBuilder'
import { BettingInformation } from './BettingInformation'
import BetEnquiryResponseDataTransferObject from '../DataTransferObjects/BetEnquiryResponseDataTransferObject'
import { BetType } from './Betting/BetType'
import ObservableMeetingInformation from './Observables/ObservableMeetingInformation'
import { enquireAllUpBet, enquireBet } from '../Services/BetEnquiryService'
import * as EventAggregator from '@classic/AppUtils/Framework/Messaging/EventAggregator'
import { handleErrorAsIs, showErrorMessage } from '../Utils/ErrorHandler'

export function doBetEnquiry(
  bettingInformation: BettingInformation,
  callback: (betEnquiryResponse: BetEnquiryResponseDataTransferObject) => void
): void {
  const betViewModelBuilder = new LegacyBetModelBuilder(bettingInformation, true, false)
  let betEnquiryPromise: Promise<BetEnquiryResponseDataTransferObject>
  if (bettingInformation.selectedBetType().betType() === BetType.AllUp) {
    betEnquiryPromise = enquireAllUpBet(betViewModelBuilder.getModel())
  } else {
    betEnquiryPromise = enquireBet(betViewModelBuilder.getModel())
  }

  betEnquiryPromise
    .then(success => {
      if (success.ExceptionMessage != undefined || success.Message != undefined) {
        const scratchedErrorCallback = () => {
          // If selected starter is scratched, refresh starters
          if (success.ExceptionMessage && success.ExceptionMessage.includes('scratched')) {
            const raceNumbersToRefresh = [
              (
                bettingInformation.meetingInformation as ObservableMeetingInformation
              ).selectedRace.raceNumber(),
            ]
            EventAggregator.publish('race-refresh-command', raceNumbersToRefresh)
          }
        }

        showErrorMessage(success.Message, success.ExceptionMessage, scratchedErrorCallback)
      } else {
        callback(success)
      }
    })
    .catch(error => {
      if (error.status === 400) {
        const caughtException = jQuery.parseJSON(error.responseText)
        showErrorMessage(caughtException.Message, caughtException.ExceptionMessage)
      } else {
        EventAggregator.publish('bet.account')

        handleErrorAsIs(0, 'Unknown')
      }
    })
}
